import { SuccessIcon } from '@/assets/icons'
import React from 'react'
import { i18n } from '@/locale/i18n'

class FeedbackSent extends React.PureComponent {
  render() {
    return (
      <div className="flex items-center gap-4">
        <SuccessIcon />

        <div className="message__text">
          <div className="message__main-text">{i18n('feedback.sent_message')}</div>
        </div>
      </div>
    )
  }
}

export default FeedbackSent
